import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import * as productActions from '../product/product.actions';
import { getProductCategories } from '../product-category/product-category.selectors';

import { ContentSection, PageHeader } from './components';
import List from '../common/components/List';

import ProductCategoryCard from '../product-category/components/ProductCategoryCard';
import {Localize} from '../../locale/localization';
import {media} from '../../utils/uiSizes';

const StyledProductsList = styled(List)`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap:20px;

  @media(min-width:992px) {
    > * {
      width: calc((100% - 1.5rem) / 2);
      max-width: 460px;
    }
  }
`;

class ProductsPage extends Component {
  componentWillMount = () => {
    const { getProducts } = this.props;
    getProducts(false);
  }

  renderProduct = (productCategory) => {
    if (productCategory.settings.order > 0) {
        return (
            <ProductCategoryCard
                key={productCategory._id}
                productCategory={productCategory}
            />
        );
    }
  }

  render() {
    const { productCategories } = this.props;
    return (
      <div>
        <PageHeader title={Localize("products.header")} />
        <ContentSection>
          <StyledProductsList
            items={productCategories}
            renderItem={this.renderProduct}
          />
        </ContentSection>
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  const productCategories = getProductCategories(state).filter((category) => !category.private);
  return {
    productCategories
  };
};

const ConnectedProductsPage = connect(
  mapStateToProps,
  Object.assign({}, productActions),
)(ProductsPage);

export default ConnectedProductsPage;


// WEBPACK FOOTER //
// ./src/modules/pages/ProductsPage.js